export default "__VITE_PUBLIC_ASSET__6053e9c9__"